import api from './api'
import {
  AdminCustomerListResponse,
  PaginationParams
} from '../types/api'

type ApiSuccessResponse<T> = {
  success?: boolean
  data: T
}

type CustomerSortField =
  | 'name'
  | 'email'
  | 'totalOrders'
  | 'totalSpent'
  | 'lastOrderDate'
  | 'registrationDate'
  | 'status'

const adminCustomerService = {
  async list(params?: {
    search?: string
    status?: 'active' | 'inactive'
    sortBy?: CustomerSortField
    sortOrder?: 'asc' | 'desc'
  } & PaginationParams): Promise<AdminCustomerListResponse> {
    const response = await api.get<ApiSuccessResponse<AdminCustomerListResponse>>(
      '/admin/customers',
      {
        params
      }
    )

    return response.data.data
  }
}

export default adminCustomerService


